import { Button, Label, Modal, Radio, Textarea } from 'flowbite-react';
import { RxCross2 } from 'react-icons/rx';

interface Props {
	isOpen: boolean;
	isSuccessfull: boolean;
	reason: string;
	setIsSuccessfull: (isSuccessfull: boolean) => void;
	setReason: (reason: string) => void;
	handleSubmit: () => void;
	handleLeave: () => void;
	setShowEndMeetingModal: (showEndMeetingModal: boolean) => void;
}

const MeetingEndModal = ({
	isOpen,
	handleSubmit,
	isSuccessfull,
	reason,
	setIsSuccessfull,
	setReason,
	setShowEndMeetingModal,
	handleLeave,
}: Props) => {
	const disableSubmitCta = !isSuccessfull && !reason;

	return (
		<>
			<Modal size={'md'} dismissible={true} show={isOpen} onClose={() => setShowEndMeetingModal(false)}>
				<Modal.Body className="relative rounded-[8px] border border-solid border-[#555770] bg-[#18222D] pt-12">
					<div>Do you recommend rescheduling this interview?</div>

					<div className="flex gap-3 mt-3">
						<div className="flex items-center gap-2">
							<Radio checked={!isSuccessfull} name={'Yes'} onChange={() => setIsSuccessfull(false)} />
							<Label className="text-white">Yes</Label>
						</div>

						<div className="flex items-center gap-2">
							<Radio checked={isSuccessfull} name={'No'} onChange={() => setIsSuccessfull(true)} />
							<Label className="text-white">No</Label>
						</div>
					</div>

					{!isSuccessfull ? (
						<div className="mt-3">
							<div>Reason for reschedule?</div>
							<Textarea value={reason} onChange={e => setReason(e.target.value)} className="mt-2" />
						</div>
					) : null}

					<div className="flex gap-3 justify-between mt-3">
						<div className="mt-4 grow-2">
							<Button className="w-full" color="purplePlaced" onClick={handleLeave}>
								Leave
							</Button>
						</div>
						<div className="mt-4 grow-2">
							<Button color="failure" className="w-full" disabled={disableSubmitCta} onClick={handleSubmit}>
								End Meeting For All
							</Button>
						</div>
					</div>
					<RxCross2
						onClick={() => setShowEndMeetingModal(false)}
						className="absolute right-[16px] top-[16px] h-[20px] w-[20px] cursor-pointer text-white"
					/>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default MeetingEndModal;
